import { API_ROUTES } from '@/constants/apiRoutes';
import { SetPasswordResponse } from '@/types/accountActivation';
import {
  ActivationChallengeValidationRequest,
  ActivationChallengeValidationResponse,
  ActivationStatusRequest,
  ActivationStatusResponse,
  SetPasswordRequest,
} from '@/types/auth';
import { api } from '@/utils/api';

export async function accountActivationSendOtpService({
  activation_code,
  userGroup,
}: ActivationStatusRequest) {
  const { data } = await api<ActivationStatusResponse>({
    url: API_ROUTES.START_ACTIVATION,
    method: 'post',
    data: {
      activation_code,
      user_group: userGroup,
    },
    isAuth: false,
  });

  return data;
}

export async function accountActivationValidateOtpService({
  activation_code,
  otp_code,
}: ActivationChallengeValidationRequest) {
  const { data } = await api<ActivationChallengeValidationResponse>({
    url: API_ROUTES.ACTIVATION_CHALLENGE_VALIDATION,
    method: 'post',
    data: {
      activation_code,
      otp_code,
    },
    isAuth: false,
  });

  return data;
}

export async function accountActivationSetPasswordService({
  password,
  set_password_code,
}: SetPasswordRequest) {
  const { data } = await api<SetPasswordResponse>({
    url: API_ROUTES.AUTH_SET_PASSWORD,
    method: 'post',
    data: {
      password,
      set_password_code,
    },
    isAuth: false,
  });

  return data;
}

export async function resendAccountActivationService({
  email,
}: {
  email: string;
}) {
  const { status } = await api({
    url: API_ROUTES.RESEND_ACTIVATION_INVITATION,
    method: 'post',
    data: { email },
    isAuth: false,
  });

  return status === 200;
}
